module.exports = __webpack_public_path__ + "img/hok2.d56c9e9a.png";